<template>
  <div>
    <span class="material-input-bar" />
    <label class="material-label">
      <slot />
    </label>
    <br v-if="$slots['default']" />
    <el-tooltip :disabled="!tooltip" class="item" effect="dark" :content="tooltip || ''" placement="top-start">
      <el-input-number
        v-model="currentValue"
        :readonly="readonly"
        :required="required"
        :disabled="disabled"
        :precision="precision"
        :step="step"
        :step-strictly="stepStrictly"
        :max="max"
        :min="min"
        :controls-position="controlsPosition"
        :placeholder="placeholder"
        @change="handleModelInput"
      >
      </el-input-number>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    value: {
      type: Number,
      default: undefined
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    precision: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    stepStrictly: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 32767
    },
    min: {
      type: Number,
      default: 0
    },
    controlsPosition: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    tooltip: [Boolean, String],
    handleModelInputExtension: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
      if (newValue < this.min) {
        this.handleModelInput(this.min);
      } else if (newValue > this.max) {
        this.handleModelInput(this.max);
      }
    }
  },
  methods: {
    handleModelInput(currentValue, oldValue) {
      this.$emit('input', currentValue, oldValue);
      this.$emit('change', currentValue, oldValue);
      this.handleModelInputExtension();
    }
  }
};
</script>
